import * as crypto from "crypto-js";

export const createToken = () => {
  return crypto.lib.WordArray.random(32).toString(crypto.enc.Hex);
};
